import React from 'react'
import { ServiceFactory } from '../services/ServiceFactory'

export const ServiceContext = React.createContext<ServiceFactory | null>(null)
